import Api from './Api';

export default {
  async getAll(data) {
    return Api.get('api/cities', { params: { search: data } });
  },
};
